import { useEffect } from "react";

const DEFAULT_TITLE = "ABC Fitness Developer Portal";

export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ABC Fitness Developer Portal` : DEFAULT_TITLE;
  }, [title]);
}
